import React from 'react';
import { Edit2 } from '@finect/tabular-icons/edit-2';
import { Check } from '@finect/tabular-icons/check';
import { Bubble } from './Bubble';
import { ActionBubble, ActionIconBlock } from './partials';
var TYPES = {
  edit: {
    icon: Edit2,
    color: 'primaryLL',
    iconColor: 'primary'
  },
  success: {
    icon: Check,
    color: 'positiveLL',
    iconColor: 'positive'
  }
};
var SIZES = {
  small: {
    icon: '24px',
    bubble: '56px'
  },
  medium: {
    icon: '32px',
    bubble: '64px'
  },
  large: {
    icon: '64px',
    bubble: '96px'
  }
};
export var BubbleWithIcon = function BubbleWithIcon(_ref) {
  var type = _ref.type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size;
  var _TYPES$type = TYPES[type],
    Icon = _TYPES$type.icon,
    color = _TYPES$type.color,
    iconColor = _TYPES$type.iconColor;
  return React.createElement("div", null, React.createElement(ActionIconBlock, null, React.createElement(ActionBubble, {
    color: iconColor,
    size: SIZES[size]
  }, React.createElement(Bubble, {
    color: color
  }), React.createElement(Icon, {
    size: "56px",
    strokeWidth: "1.5"
  }))));
};